// swiper.js
import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination, Mousewheel, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Expose globally so inline template scripts can initialise Swiper instances
window.Swiper = Swiper;
window.SwiperModules = { Autoplay, EffectFade, Navigation, Pagination, Mousewheel, Scrollbar };

function initCarouselSwiper() {
	var swipers = document.querySelectorAll(".card-swiper");

	swipers.forEach(function (parent) {
		console.log("Initializing swiper for", parent);
		//Find carousel container underneath this
		//Find ..carousel-swiper-container inside parent

		var swiperContainer = parent;

		var slidesPerView = swiperContainer.getAttribute("data-swiper-slides-per-view") || 3;

		new Swiper(swiperContainer, {
			modules: [Navigation, Pagination, Mousewheel, Scrollbar],
			// Swiper options here
			mousewheel: {
				forceToAxis: true,
			},
			lazy: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: ".swiper-btn-next",
				prevEl: ".swiper-btn-prev",
			},
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
			},
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		});
	});
}
initCarouselSwiper();
